import { apiRequest } from './apiClient';

const BASE_URL = '/admin/api/results';

export const userResultsService = {
  // Get events for user results
  getEvents: async (page = 1, limit = 20) => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });
    
    return await apiRequest({
      endpoint: `${BASE_URL}/events?${params.toString()}`,
      method: 'GET',
      auth: true
    });
  },

  // Get ranked users for a specific event (leaderboard)
  getEventUsers: async (eventId, page = 1, limit = 20) => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });
    
    return await apiRequest({
      endpoint: `${BASE_URL}/events/${eventId}/users?${params.toString()}`,
      method: 'GET',
      auth: true
    });
  }
};

export default userResultsService;
